import { ACTIVE_CHAIN } from "src/constants";

export const state = {
  // Balance and token info
  bctBalance: 0,
  usdcBalance: null,
  balances: {},
  remainingAllocation: null,
  gasPrice: null,

  // Sign and authentication
  signInfo: {},
  isAuthenticated: false,
  authSessionExpiresAt: null,
  isLogging: false,
  isLogin: false,
  cantLogin: false,
  loginAccount: {},
  currentUser: null,
  carbonSession: {
    businessWalletAddress: null,
    authWalletAddress: null,
  },

  // Dialog states
  dialogMetamask: false,
  dialogWeb3Auth: false,
  dialogLedger: false,
  dialogMetaKeep: false,

  // Connection state
  isConnected: false,
  accounts: [],
  currentAccount: {},
  adapter: null,
  provider: null,
  connectingMetaKeep: false,
  walletInfo: null,

  // Network information
  networkId: String(ACTIVE_CHAIN.chainId),
  networkName: "",
  requiredNetworkName: "",
  networkSettings: null,

  // Project and offering data
  projects: [],
  offeringFactoryContract: null,
  liveOfferings: [],
  createdOffering: "",
  createdProject: "",
  offeringState: null,
  allocatedOfferings: {},

  // Transaction results
  approvalResult: null,
  bidResult: null,
  txUrl: null,
  withdrawResult: null,
  userWithdrawTxUrl: null,

  // Withdrawal and funds
  isCancelled: false,
  couldWithdrawingBackFunds: false,
  isEligibleForWithdrawingBackFunds: false,
  fundsPaid: 0,
  potentialRefund: 0,
  remainingFundsUnlocked: {},
  nextUnlockTime: -1,
  listingEnd: -1,
  paymentSlices: -1,
  fundsCollected: -1,
  currentPaymentSlice: -1,

  // Commission data
  usdCommission: -1,
  carbonCreditCommission: -1,
  remainingDeveloperCommission: -1,
  remainingDeveloperCarbonCreditCommission: -1,
  commissionWithdrawn: -1,
  developerCommissionTransfered: null,
  developerCarbonCreditCommissionsTransferred: null,
  usdCommissionTransferred: null,
  carbonCreditCommissionsTransferred: null,

  // Contract addresses
  offeringSmartContractAddress: null,

  // Error handling
  walletErrorMessage: "",
  serverError: null,

  // Loading states
  isLoading: false,

  // AML and audit
  amlStatusResponse: null,
  auditWindowOpen: null,
  unsuccessfulAudit: null,
  successfulAudit: null,
  auditPeriod: -1,

  // Admin and roles
  adminRole: null,

  // Web3Auth specific
  web3auth: null,
  walletServicesPlugin: null,

  // Developer tokens
  developerTokensBurned: false,

  // Staking info
  poolSnapshot: null,

  // Cached backend user records (pre-credits/species/to-burn)
  userRecordsCache: null
};
